import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { selectLocale } from '@/store/selectors/commonSelectors';
import { getDateFilterOptions, mapDateFilterItems } from '@/utils/dateFilter';
import { selectAuthToken } from '@/store/selectors/authSelectors';
import { DateFilter } from '@/components/DateFilter';
import { useBffRequest } from '@/hooks/useBffRequest';
import BffApiService from '@/shared/bffApiService';
import PaginatedTable from '@/components/shared/paginated-table/PaginatedTable';
import { mapGameTransactionHistoryItems } from '@/utils/transaction-history-utils';

const GamingHistory = (): JSX.Element | null => {
  const locale = useSelector(selectLocale);
  const token = useSelector(selectAuthToken);
  const intl = useIntl();
  const dateFilterOptions = getDateFilterOptions();
  const dateFilterItems = mapDateFilterItems(dateFilterOptions);
  const {
    request: fetchGamesTransactionsRequest,
    data: fetchGamesTransactionsData,
    loading: fetchGamesTransactionsLoading,
  } = useBffRequest(BffApiService.fetchGamesTransactions);

  const noDataMsg = intl.formatMessage({
    id: 'history.noTransactions',
  });
  const headerCells = ['history.game', 'history.bet', 'history.win', 'history.date'].map(id =>
    intl.formatMessage({ id }),
  );

  const selectDateRange = (id: number) => {
    const { fromDate, toDate } = dateFilterOptions[id].dateRange;
    fetchGamesTransactionsRequest({
      axiosConfig: { params: { fromDate, toDate } },
    });
  };

  console.log(dateFilterItems);

  // This effect will trigger the initial request for the Last 30 days of history
  useEffect(() => {
    const { fromDate, toDate } = dateFilterOptions[1].dateRange;
    fetchGamesTransactionsRequest({
      axiosConfig: { params: { fromDate, toDate } },
    });
  }, [token]);

  if (!locale) {
    return null;
  }

  const mappedGamingTransactionHistoryItems = mapGameTransactionHistoryItems(
    locale,
    fetchGamesTransactionsData,
  );

  return (
    <>
      <DateFilter items={dateFilterItems} selectDateRange={selectDateRange} />
      <div className="mt-4">
        <PaginatedTable
          data={mappedGamingTransactionHistoryItems}
          headerCells={headerCells}
          emptyDataMessage={noDataMsg}
          loading={fetchGamesTransactionsLoading}
        />
      </div>
    </>
  );
};

export default GamingHistory;
